/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedProductDependencyList } from '../models/PaginatedProductDependencyList';
import type { PatchedProductDependency } from '../models/PatchedProductDependency';
import type { ProductDependency } from '../models/ProductDependency';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ProductsDependenciesService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedProductDependencyList
     * @throws ApiError
     */
    public productsDependenciesList({
        page,
        pageSize,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
    }): CancelablePromise<PaginatedProductDependencyList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/products-dependencies/',
            query: {
                'page': page,
                'page_size': pageSize,
            },
        });
    }

    /**
     * @returns ProductDependency
     * @throws ApiError
     */
    public productsDependenciesCreate({
        requestBody,
    }: {
        requestBody: ProductDependency,
    }): CancelablePromise<ProductDependency> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/products-dependencies/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProductDependency
     * @throws ApiError
     */
    public productsDependenciesRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this product dependency.
         */
        id: number,
    }): CancelablePromise<ProductDependency> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/products-dependencies/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns ProductDependency
     * @throws ApiError
     */
    public productsDependenciesUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this product dependency.
         */
        id: number,
        requestBody: ProductDependency,
    }): CancelablePromise<ProductDependency> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/products-dependencies/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProductDependency
     * @throws ApiError
     */
    public productsDependenciesPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this product dependency.
         */
        id: number,
        requestBody?: PatchedProductDependency,
    }): CancelablePromise<ProductDependency> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/products-dependencies/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public productsDependenciesDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this product dependency.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/products-dependencies/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
